module.exports = __webpack_public_path__ + "img/Menu-17.6c42896b.webp";